<template>
  <div class="general-tab">
    <efficiency-dropdown
      :tab-info="tabInfo"
      :selected-norm="selectedNorm"
      @change-norm="onChangeNorm"
    />
    <general-tab-cards-section
      class="mt-3 avoid-break"
      :cards="cards"
      :loading="loadingCards"
    />
    <calculated-temperature-chart
      class="mt-3 avoid-break"
      :loading="loadingCalculatedTemperature"
      :key="updateKey"
      :chart-data="calculatedTemperatureChartData"
    />
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import Service
  from '@/domain/services/installation/engineering/coolingEfficiency/coolingEfficiencyService';
import EfficiencyDropdown
  from '@/domain/components/installation/engineering/coolingEfficiency/EfficiencyDropdown';
import GeneralTabCardsSection
  from '@/domain/components/installation/engineering/coolingEfficiency/general/CardsSection';
import CalculatedTemperatureChart
  from '@/domain/components/installation/engineering/coolingEfficiency/general/CalculatedTemperatureChart';

export default {
  name: 'CoolingEfficiencyGeneralTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    EfficiencyDropdown,
    GeneralTabCardsSection,
    CalculatedTemperatureChart,
  },
  data: vm => ({
    selectedNorm: vm.tabInfo.selectedNorm,
    cards: [],
    norms: [],
    loadingCards: false,
    loadingNorms: false,
    updateKey: 0,
    calculatedTemperatureChartData: {},
    loadingCalculatedTemperature: false,
  }),
  created() {
    this.initEvents();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.removeEvents();
  },
  methods: {
    initEvents() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData);
    },
    removeEvents() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData);
    },
    updateRenderKey() {
      this.updateKey += 1;
    },
    getCalculatedTemperature(normId, showLoading) {
      const { assetModuleId } = this.$route.params;
      this.loadingCalculatedTemperature = showLoading;
      Service.getCalculatedTemperature(assetModuleId, normId).then((response) => {
        this.calculatedTemperatureChartData = response;
        this.updateRenderKey();
      }).finally(() => {
        this.loadingCalculatedTemperature = false;
      });
    },
    onChangeNorm(event) {
      this.selectedNorm = event;
      this.getCardsByNorm(true);
      this.getCalculatedTemperature(event, true);
    },
    getCardsByNorm(showLoading = false) {
      const { assetModuleId } = this.$route.params;
      this.loadingCards = showLoading;
      Service.getCardsByNorm(assetModuleId, this.selectedNorm)
        .then((response) => {
          this.cards = response;
        })
        .finally(() => {
          this.loadingCards = false;
        });
    },
    getNorms() {
      const { assetModuleId } = this.$route.params;
      this.loadingNorms = true;
      Service.getNorms(assetModuleId).then((response) => {
        this.norms = response;
      }).finally(() => {
        this.loadingNorms = false;
      });
    },
    refreshData(showLoading = false) {
      if (this.tabInfo.status?.lastUpdate) {
        this.getNorms();
        this.getCardsByNorm(showLoading);
        this.getCalculatedTemperature(this.selectedNorm, showLoading);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.general-tab
  padding: 15px
  border: 1px solid $color-border-gray
  border-radius: 3px
  @media print
    page-break-after: always

</style>
